import React, { useState, useEffect } from 'react';
import {
	Button,
	TextField,
	Typography,
	FormControl,
	InputLabel,
	CircularProgress,
	InputAdornment,
  Checkbox,
  FormGroup,
  FormControlLabel
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
	AccountCircleOutlined,
	EmailOutlined,
	Lock,
	LockOutlined,
	PhoneAndroidOutlined,
} from '@material-ui/icons';
import * as yup from 'yup';
import 'yup-phone';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useHistory } from 'react-router-dom';
import useStyles from '../../styles/style';
import { roleAction } from '../../redux/actions/roleAction';
import {
	registerAction,
	nidAction,
	emailAction,
	phoneAction,
} from '../../redux/actions/userAction';
import IconTextField from '../helpers/IconTextField';
import Select from 'components/Select';
import { Link } from 'react-router-dom';


const Register = () => {
	const { t } = useTranslation();
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();

	const [nid, setNid] = useState('');
	const [userEmail, setUserEmail] = useState();
	const [userPhone, setUserPhone] = useState();
  const [agreeTerms, setAgreeTerms] = useState();

	const registerSchema = yup.object({
		password: yup
			.string()
			.min(6, `${t('password-error')}`)
			.required(),
		confirmationPassword: yup
			.string()
			.oneOf([yup.ref('password')], `${t('confirm-password-error')}`),
	});

	const register = useSelector(state => state.register);
	const checkNid = useSelector(state => state.nid);
	const checkEmail = useSelector(state => state.email);
	const checkPhone = useSelector(state => state.phone);

  const handleDisable = (props, register, phone) => {
    return !props.values.nationalId ||
      !props.values.email ||
      !phone ||
      !props.values.password ||
      !props.values.confirmationPassword ||
      Object.keys(props.errors).length !== 0 ||
      register.loading ||
      !agreeTerms
      ? // nid.error
        true
      : false;
  };

	const handleBlurNationalId = () => {
		dispatch(nidAction({ nationalId: nid }));
	};

	const handleBlurEmail = () => {
		dispatch(emailAction({ email: userEmail }));
	};

	const handlePhoneBlur = () => {
		dispatch(phoneAction({ phone: `+${userPhone}` }));
	};

	const handleSubmit = values => {
		const { nationalId, ...formValues } = values;
		dispatch(
			registerAction({
				...formValues,
				nationalId: nationalId.toString(),
				phone: `+${userPhone}`,
			})
		);
	};

	const national_id_error = checkNid.error;

	useEffect(() => {
		if (register.status === 201) {
			history.push('/success');
		}
	}, [register]);

	return (
		<div>
			<Typography variant='body1' style={{ color: '#198754' }}>
				{register.message}
			</Typography>
			<Typography color='secondary' variant='body2'>
				{register.error}
			</Typography>
			<Typography variant='h6' className={classes.authText}>
				{t('register-title')}
			</Typography>
			<Formik
				validationSchema={registerSchema}
				initialValues={{
					nationalId: '',
					email: '',
					phone: '',
					password: '',
					confirmationPassword: '',
				}}
				onSubmit={values => handleSubmit(values)}
			>
				{props => (
					<Form onSubmit={props.handleSubmit}>
						<IconTextField
							id='nationalId'
							label={<span className={classes.authText}>{t('id-number')}</span>}
							name='nationalId'
							onChange={e => {
								props.handleChange(e);
								const id = e.target.value.substring(0, 16).toString();
								setNid(id);
							}}
							onBlur={handleBlurNationalId}
							value={nid}
							error={checkNid.error !== ''}
							helperText={
								props.values.nationalId !== '' &&
								t('nid-error', { national_id_error })
							}
							icon={<AccountCircleOutlined />}
						/>
						<IconTextField
							id='email'
							label={<span className={classes.authText}>{t('email')}</span>}
							name='email'
							onChange={e => {
								props.handleChange(e);
								setUserEmail(e.target.value);
							}}
							onBlur={handleBlurEmail}
							value={props.values.email}
							error={checkEmail.error !== ''}
							helperText={props.values.email !== '' && checkEmail.error}
							icon={<EmailOutlined />}
						/>
						<PhoneInput
							country='rw'
							onlyCountries={['rw']}
							disableDropdown={true}
							placeholder={t('phone-label')}
							defaultErrorMessage='eror'
							containerStyle={{
								marginTop: '15px',
								marginBottom: '10px',
							}}
							inputStyle={{
								width: '100%',
								height: '40px',
								borderRadius: '2px',
								border: '1px solid inherit',
							}}
							inputProps={{
								name: 'phone',
								required: true,
							}}
							onChange={e => {
								props.handleChange(e);
								setUserPhone(e);
							}}
							onBlur={handlePhoneBlur}
							value={props.values.phone}
							InputProps={{
								startAdornment: (
									<InputAdornment position='start'>
										<PhoneAndroidOutlined />
									</InputAdornment>
								),
							}}
						/>
						<Typography color='secondary' variant='body2'>
							{checkPhone.error}
						</Typography>
						<IconTextField
							type='password'
							size='small'
							id='password'
							label={<span className={classes.authText}>{t('password')}</span>}
							name='password'
							onChange={props.handleChange('password')}
							value={props.values.password}
							error={
								props.values.password !== '' &&
								Object.prototype.hasOwnProperty.call(props.errors, 'password')
							}
							helperText={props.values.password !== '' && props.errors.password}
							icon={<LockOutlined />}
						/>
						<IconTextField
							type='password'
							id='confirmationPassword'
							label={
								<span className={classes.authText}>
									{t('confirm-password')}
								</span>
							}
							name='confirmationPassword'
							onChange={props.handleChange('confirmationPassword')}
							value={props.values.confirmationPassword}
							error={
								props.values.confirmationPassword !== '' &&
								Object.prototype.hasOwnProperty.call(
									props.errors,
									'confirmationPassword'
								)
							}
							helperText={
								props.values.confirmationPassword !== '' &&
								props.errors.confirmationPassword
							}
							icon={<Lock />}
						/>
          <FormGroup>
            <FormControlLabel control={<Checkbox onChange={(e,checked)=>setAgreeTerms(checked)} color="success" />} label={
            <label className='text-dark my-3' >
             {t('by-clicking-signup')} <Link to='/support/legal-information' className='link-text text-decoration-underline'>{t('terms-of-use')}</Link>.
              </label>
            } />
          </FormGroup>
						<Button
							type='submit'
							variant='contained'
							disabled={handleDisable(props, register, userPhone)}
							className={classes.submit}
						>
							{register.loading ? (
								<>
									<CircularProgress size={20} />
									&nbsp;
									{t('loading')}
								</>
							) : (
								t('register')
							)}
						</Button>
					</Form>
				)}
			</Formik>
		</div>
	);
};

export default Register;
